import { createModel, RematchDispatch } from '@rematch/core';
import { produce } from 'immer';

import baseEntity from './base.entity';
import { RootModel } from '../models';
import { TourTypes } from '../../types';
import { getTourByCode } from '../../services/tour.service';
import { convertTourResponse } from '../../utils';

export const storeName = 'tourEntity';

export const tourEntity = createModel<RootModel>()({
  name: storeName,
  state: { ids: {} },
  reducers: {
    ...baseEntity,
    saves: produce((state, entities: TourTypes[]) => {
      (entities || []).forEach((entity: TourTypes) => {
        state.ids[entity.code] = entity;
      });
    }),
  },
  effects: (dispatch: RematchDispatch<typeof tourEntity>) => ({
    async loadByClientUrl(payload: { code: string; url: string }, state: RootModel) {
      const { code, url } = payload;

      const entities: { [key: string]: TourTypes } = state[storeName].ids;
      const savedItem: TourTypes = entities[code];
      if (savedItem) return savedItem;

      const response = await getTourByCode(code);
      if (!response) return { notFound: true };
      if (response.notFound) return response;

      const tour = convertTourResponse({ ...response, uri: url });
      this.saves([tour]);
      return tour;
    },
  }),
});

export default tourEntity;
